// eslint-disable-next-line no-restricted-imports
import styled from '@emotion/styled';
import { useNavigateBack } from '@iheartjane/menu';
import { Button, Flex, Typography } from '@iheartjane/reefer';
import { useEffect, useMemo, useState } from 'react';
import { useNavigate } from 'react-router';

import { Modal } from '@jane/kiosk/components';
import type { RootLoaderType } from '@jane/kiosk/data-access';
import { useKioskSpacing, useTypedRouteLoaderData } from '@jane/kiosk/hooks';
import { useResetKiosk } from '@jane/kiosk/providers';

const StyledButton = styled(Button)(() => ({
  flexBasis: '50%',
  flexGrow: 1,
  flexShrink: 1,
}));

export const SwitchStores = () => {
  const { storeId, whoami } = useTypedRouteLoaderData<RootLoaderType>('root');
  const goBack = useNavigateBack(`stores/${storeId}/menu`);
  const { getKioskSpacing, isIpad } = useKioskSpacing();
  const navigate = useNavigate();
  const { isResetting, resetKiosk } = useResetKiosk();

  const [confirmed, setConfirmed] = useState(false);

  const storeIdToSwitch = useMemo(
    () => whoami?.stores?.filter(({ id }) => storeId !== id)[0].id,
    [storeId, whoami?.stores]
  );

  useEffect(() => {
    if (!isResetting && confirmed) {
      navigate(`/stores/${storeIdToSwitch}/menu`);
    }
  }, [confirmed, isResetting, navigate, storeIdToSwitch]);

  return (
    <Modal
      appId="root"
      contentLabel="Switch Stores"
      onRequestClose={() => goBack()}
      open
      overflow="scroll"
      variant="dialogue"
    >
      <Modal.Content>
        <Typography variant={isIpad ? 'h3-semibold' : 'h2-semibold'}>
          Are you sure you want to change menus?
        </Typography>
        <Typography mt={getKioskSpacing(24, 8)}>
          Switching to a different menu will reset your session, removing all
          products in your bag.
        </Typography>
        <Flex
          alignItems="center"
          flexDirection="row"
          justifyContent="center"
          mt={getKioskSpacing(32, 24)}
        >
          <StyledButton
            variant="tertiary"
            label="Cancel"
            mr={getKioskSpacing(24, 16)}
            size={isIpad ? 'small' : 'large'}
            onClick={() => goBack()}
          />
          <StyledButton
            label="Confirm"
            size={isIpad ? 'small' : 'large'}
            onClick={() => {
              setConfirmed(true);
              resetKiosk({ shouldNavigateToMenu: false });
            }}
          />
        </Flex>
      </Modal.Content>
    </Modal>
  );
};
